import * as React from "react";
import { Lightbox, LightboxType } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { Div } from "../../../../../../../../react-core/Html/Div";
import { PartLoading } from "../../../../../../../../react-core/Html/PartLoading";
import { Guid } from "../../../../../../../../react-core/Utils/Guid";
import { AreaGroupType } from "../../../../../../../../Wrap/Constants/Enums/Domain/AreaGroupType";
import { AssetClassType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { InvestmentRegionAllocationModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentRegionAllocationModel";
import { RegionViewSelect } from "../../../../../../Common/RegionViewSelect";
import { InsightsAction } from "../Action/InsightsAction";
import { AreaGroupTypeMap, Contents } from "../Resource/Contents";
import { InsightsStore, InvestmentRegionAllocationStore } from "../Store/Variable";
import { UnmountClosed } from "react-collapse";
import { InvestmentGeographicAllocationModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentGeographicAllocationModel";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { AreaGroupModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/AreaGroupModel";
import { CommonHelper, Dictionary } from "../../../../../../../../react-core/Helpers/CommonHelper";

interface IRegionAllocationPopupViewProps extends React.Props<RegionAllocationPopupView> {
    showBox: boolean;
    areaCode: AreaGroupType;
    asAt: Date;
    accountSelectValue: string[];
    callBack: (val: boolean) => void;
}

interface IRegionAllocationPopupViewState {
    areaSelectValue: AreaGroupType;
    regionAllocationList: Array<InvestmentRegionAllocationModel>;
    tempAllocationList: any[];
    expands?: expandedModel[];
    isLoading?: boolean;
    hasData?: boolean;
}

export class expandedModel {
    id: string;
    index: number;
    isOpen: boolean;
    details: Array<InvestmentRegionAllocationModel>;
}

export class RegionAllocationPopupView extends React.Component<
    IRegionAllocationPopupViewProps,
    IRegionAllocationPopupViewState
> {
    constructor(props: IRegionAllocationPopupViewProps) {
        super(props);

        this.state = {
            areaSelectValue: this.props.areaCode >= 0 ? this.props.areaCode : AreaGroupType.ALL,
            regionAllocationList: [],
            tempAllocationList: [],
            expands: [],
            isLoading: true,
            hasData: false,
        };
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    public componentDidMount() {
        const { accountSelectValue, asAt } = this.props;
        InsightsAction.getInvestmentRegionAllocation(accountSelectValue, AssetClassType.Tier1, asAt, (callBack) => {
            this.setState({
                regionAllocationList: callBack,
                hasData: true,
            });
            this.getRegionAllocationByAreaGroupCode();
        });

        const areaGroup = InsightsStore.getRegionGroup();

        if (!areaGroup) {
            InsightsAction.getAssetAreaGroup();
        }
    }

    public render(): JSX.Element {
        return <Div>{this.props.showBox ? this.renderModal() : null}</Div>;
    }

    private renderModal(): JSX.Element {
        const { areaSelectValue, hasData } = this.state;
        let cssWrapper = "";

        let elementRender: JSX.Element = this.renderLoading();

        if (hasData) {
            elementRender = <div>{this.getModalBody()}</div>;
        }

        if (areaSelectValue == AreaGroupType.ALL) {
            cssWrapper = "is-default-lightbox is-wider";
        } else {
            cssWrapper = "is-default-lightbox is-wider";
        }

        return (
            <Lightbox
                show={this.props.showBox}
                title={Contents.Geographic}
                contentAfterTitle={null}
                onClose={() => this.props.callBack(false)}
                type={LightboxType.Modal}
                unclosable={false}
                noOverlay={false}
                noAutofocus={false}
                cssWrapper={cssWrapper}
            >
                {elementRender}
            </Lightbox>
        );
    }

    private renderLoading() {
        return <PartLoading isLoading={true}></PartLoading>;
    }

    private getAccoutviewDictionays(val: Array<AreaGroupModel>, isShowAll): Dictionary[] {
        const options: Dictionary[] = [];

        if (isShowAll) {
            options.push({ key: AreaGroupTypeMap[AreaGroupType.ALL], value: "All" });
        }

        if (val) {
            val.map((item) => {
                options.push({ key: item.Code, value: item.DisplayName });
            });
        }
        return options;
    }

    private getModalBody(): JSX.Element {
        //Render Region drowdown list.
        const { areaSelectValue } = this.state;
        const { areaCode } = this.props;
        let isShowAll = false;

        if (areaCode == null) {
            isShowAll = true;
        }

        return (
            <div className="content">
                <div className="row">
                    <div className="col-12 col-sm-auto col-middle">
                        <RegionViewSelect
                            isShowAll={isShowAll}
                            selected={AreaGroupTypeMap[areaSelectValue]}
                            onChange={(val) => {
                                const regionGroup = InsightsStore.getRegionGroup();
                                const _options = [];

                                if (regionGroup) {
                                    if (isShowAll) {
                                        _options.push(AreaGroupTypeMap[AreaGroupType.ALL]);
                                    }
                                    regionGroup.map((item) => {
                                        _options.push(item.Code);
                                    });
                                }

                                const dictionays = regionGroup
                                    ? this.getAccoutviewDictionays(regionGroup, isShowAll)
                                    : [];
                                this.addEvent({
                                    event: "insightstab_interaction",
                                    eventParameters: {
                                        eventCategory: eventCategoryForGTM.insightsTab,
                                        eventAction: "interactions",
                                        eventLabel: CommonHelper.getOptionsTxt(val, dictionays),
                                    },
                                });
                                console.log(CommonHelper.getOptionsTxt(val, dictionays));
                                this.changeAreaGroupCode(val);
                            }}
                        />
                    </div>
                </div>
                {this.renderTable()}
            </div>
        );
    }

    private changeAreaGroupCode(val: string) {
        this.setState({ areaSelectValue: AreaGroupTypeMap[val] }, () => {
            this.getRegionAllocationByAreaGroupCode();
        });
    }

    private renderTable(): JSX.Element {
        return (
            <div className="table-scrollable">
                <table className="table-expandable no-sided-padding">
                    <thead>
                        <tr>{this.renderThead()}</tr>
                    </thead>
                    {this.renderTBody()}
                </table>
            </div>
        );
    }

    private renderThead(): JSX.Element[] {
        const tHead: JSX.Element[] = [];
        const { areaCode } = this.props;
        const { areaSelectValue } = this.state;
        const regionGroup: Array<any> = InsightsStore.getRegionGroup();

        tHead.push(
            <th key={Guid.getNext()} className="cell-34">
                Investments
            </th>
        );

        if (!areaCode && regionGroup && areaSelectValue === AreaGroupType.ALL) {
            regionGroup.sort((a, b) => a.SortOrder - b.SortOrder);
            regionGroup.map((item, index) => {
                tHead.push(
                    <th key={Guid.getNext() + index} className="cell-5 cell-right">
                        {item.DisplayName}
                    </th>
                );
            });

            tHead.push(
                <th className="cell-5 cell-right" key={Guid.getNext()}>
                    {this.displayTotalLabel()}
                </th>
            );
        } else {
            tHead.push(
                <th key={Guid.getNext()} className="cell-5 cell-right">
                    Allocation
                </th>
            );
        }

        return tHead;
    }

    private renderTheadHidden(): JSX.Element[] {
        const tHead: JSX.Element[] = [];
        const { areaCode } = this.props;
        const { areaSelectValue } = this.state;
        const regionGroup: Array<any> = InsightsStore.getRegionGroup();

        tHead.push(
            <th key={Guid.getNext()} className="first-cell">
                <div>Investments</div>
            </th>
        );

        if (!areaCode && regionGroup && areaSelectValue === AreaGroupType.ALL) {
            regionGroup.sort((a, b) => a.SortOrder - b.SortOrder);
            regionGroup.map((item, index) => {
                tHead.push(
                    <th key={Guid.getNext() + index}>
                        <div>{item.DisplayName}</div>
                    </th>
                );
            });

            tHead.push(
                <th key={Guid.getNext()}>
                    <div>{this.displayTotalLabel()}</div>
                </th>
            );
        } else {
            tHead.push(
                <th key={Guid.getNext()}>
                    <div> Allocation</div>
                </th>
            );
        }

        return tHead;
    }

    private renderTBody(): JSX.Element[] {
        const { regionAllocationList, areaSelectValue, expands, isLoading } = this.state;
        const { areaCode } = this.props;
        const body: JSX.Element[] = [];
        const tBodyElement: JSX.Element[] = [];
        let total = 0;

        if (areaCode == null && areaSelectValue === AreaGroupType.ALL) {
            //View full details
            const nonModelPortfolioList: Array<InvestmentRegionAllocationModel> = regionAllocationList.filter(
                (x) => x.SecurityType.toUpperCase() != "MODEL"
            );
            const modelPortfolioList: Array<InvestmentRegionAllocationModel> = regionAllocationList.filter(
                (x) => x.SecurityType.toUpperCase() == "MODEL"
            );

            modelPortfolioList.map((item, index) => {
                const _isOpen =
                    expands &&
                    expands.length > 0 &&
                    expands.filter((x) => x.index === index).length > 0 &&
                    expands.filter((x) => x.index === index)[0].isOpen;
                const _btnClass = _isOpen ? "row-toggle expanded" : "row-toggle";
                const expanded = _isOpen ? true : false;
                total += item.TotalValue;

                tBodyElement.push(
                    <tr key={Guid.getNext() + index} className="te-mainrow">
                        <td onClick={() => this.toggle(item.InstrumentCode, index)}>
                            <div className="row narrow-gutter nowrap">
                                <div className="col-auto">
                                    <button className={_btnClass} aria-expanded={expanded}>
                                        <span className="sr-only">Expand row</span>
                                    </button>
                                </div>
                                <div className="col-auto cell-right">{item.DisplayName}</div>
                            </div>
                        </td>
                        {this.renderInvestmentRegionAllocation(item)}
                        <td className="cell-right">{(item.TotalValue * 100).toFixed(2)}%</td>
                    </tr>
                );
                tBodyElement.push(
                    <tr className="te-subrow" key={Guid.getNext()}>
                        <td className="pl-0" colSpan={12}>
                            <UnmountClosed isOpened={_isOpen}>
                                {isLoading ? (
                                    <PartLoading isLoading={true} />
                                ) : (
                                    this.renderRealExpendElement(index, true)
                                )}
                            </UnmountClosed>
                        </td>
                    </tr>
                );
            });

            nonModelPortfolioList.map((item, index) => {
                total += item.TotalValue;
                tBodyElement.push(
                    <tr key={Guid.getNext() + index} className="te-mainrow">
                        <td>{item.DisplayName}</td>
                        {this.renderInvestmentRegionAllocation(item)}
                        <td className="cell-5 cell-right">{(item.TotalValue * 100).toFixed(2)}%</td>
                    </tr>
                );
            });

            body.push(<tbody key={Guid.getNext()}>{tBodyElement}</tbody>);
            body.push(
                <tfoot key={Guid.getNext()}>
                    <tr className="total te-mainrow">
                        <td className="transposed-title total">{this.displayTotalLabel()}</td>
                        {this.renderAllRegionTotal()}
                        <td className="transposed-mt cell-right">{(total * 100).toFixed(2)}%</td>
                    </tr>
                </tfoot>
            );
        } else {
            //Select non-all region.
            this.populateTBody(body);
        }

        return body;
    }

    private populateTBody(body: JSX.Element[]) {
        let total = 0;
        const tBodyElement: JSX.Element[] = [];

        const { tempAllocationList, expands, isLoading, areaSelectValue } = this.state;
        let nonModelPortfolioList: Array<any> = tempAllocationList.filter(
            (x) => x.SecurityType.toUpperCase() !== Contents.Model
        );
        let modelPortfolioList: Array<any> = tempAllocationList.filter(
            (x) => x.SecurityType.toUpperCase() === Contents.Model
        );
        let allocation = "-";

        if (areaSelectValue !== AreaGroupType.CASH) {
            nonModelPortfolioList = nonModelPortfolioList.filter((x) => x.SecurityType.toUpperCase() !== Contents.Cash);
            modelPortfolioList = modelPortfolioList.filter((x) => x.SecurityType.toUpperCase() !== Contents.Cash);
        }

        modelPortfolioList.map((item, index) => {
            allocation = "-";
            total += item.Allocation;
            const _isOpen =
                expands &&
                expands.length > 0 &&
                expands.filter((x) => x.index === index).length > 0 &&
                expands.filter((x) => x.index === index)[0].isOpen;
            const _btnClass = _isOpen ? "row-toggle expanded" : "row-toggle";
            const expanded = _isOpen ? true : false;

            if (Number(item.Allocation.toFixed(2) != 0)) {
                allocation = item.Allocation.toFixed(2) + "%";
            }

            tBodyElement.push(
                <tr key={Guid.getNext() + index} className="te-mainrow">
                    <td onClick={() => this.toggle(item.InstrumentCode, index)}>
                        <div className="row narrow-gutter nowrap">
                            <div className="col-auto">
                                <button className={_btnClass} aria-expanded={expanded}>
                                    <span className="sr-only">Expand row</span>
                                </button>
                            </div>
                            <div className="col-auto">{item.DisplayName}</div>
                        </div>
                    </td>
                    <td className="cell-right">{allocation}</td>
                </tr>
            );

            tBodyElement.push(
                <tr className="tr-nested" key={Guid.getNext()}>
                    <td colSpan={8} className="pl-0 pr-0 pt-0 pb-0">
                        <UnmountClosed isOpened={_isOpen}>{this.renderRealExpendElement(index)}</UnmountClosed>
                    </td>
                </tr>
            );
        });

        nonModelPortfolioList.map((item, index) => {
            allocation = "-";
            total += item.Allocation;

            if (Number(item.Allocation.toFixed(2) != 0)) {
                allocation = item.Allocation.toFixed(2) + "%";
            }

            tBodyElement.push(
                <tr key={index + Guid.getNext()} className="te-mainrow">
                    <td>{item.DisplayName}</td>
                    <td className="cell-right">{allocation}</td>
                </tr>
            );
        });

        // Render per region total from Geographical allocation in Insight page
        const regionGroupTotalList: Array<InvestmentGeographicAllocationModel> = InvestmentRegionAllocationStore.getData();
        const regionTotal = regionGroupTotalList.filter((x) => x.AreaGroupType == areaSelectValue)[0];

        body.push(<tbody key={Guid.getNext()}>{tBodyElement}</tbody>);
        body.push(
            <tfoot key={Guid.getNext()}>
                <tr className="total te-mainrow">
                    <td className="transposed-title total">{this.displayTotalLabel()}</td>
                    {/* <td className="transposed-mt cell-right">{total.toFixed(2)}%</td> */}
                    <td className="transposed-mt cell-right">{regionTotal.Value.toFixed(2)}%</td>
                </tr>
            </tfoot>
        );
    }

    private renderRealExpendElement(index: number, isAllRegion?: boolean): JSX.Element {
        return (
            <div className="te-subwrap">
                <div className="nested-table">
                    <table className="mb-0">
                        <thead className="thead-hidden">
                            <tr>{this.renderTheadHidden()}</tr>
                        </thead>
                        <tbody>{this.renderEpendTrs(index, isAllRegion)}</tbody>
                    </table>
                </div>
            </div>
        );
    }

    private renderEpendTrs(index: number, isAllRegion?: boolean): JSX.Element[] {
        const { expands } = this.state;
        const model = expands.filter((x) => x.index === index)[0];
        const modelAllocation = model != null ? model.details : Array<InvestmentRegionAllocationModel>();
        const trs: JSX.Element[] = [];
        let modelTotal = 0;

        modelAllocation.map((item) => {
            modelTotal += item.TotalValue;
            //Underlying assets Content
            trs.push(
                <tr key={Guid.getNext() + index}>
                    <td>{item.DisplayName}</td>
                    {isAllRegion ? this.renderInvestmentRegionAllocation(item) : null}
                    <td className="cell-5 cell-right">{(item.TotalValue * 100).toFixed(2)}%</td>
                </tr>
            );
        });
        //Underlying assets total
        trs.push(
            <tr key={Guid.getNext()} className="sub-total">
                <td className="transposed-title total">Model total</td>
                {isAllRegion ? this.renderAllRegionTotal(modelAllocation, true) : null}
                <td className="transposed-mt cell-right">{(modelTotal * 100).toFixed(2)}%</td>
            </tr>
        );

        return trs;
    }

    private renderAllRegionTotal(
        modelPortfolioAllocation?: InvestmentRegionAllocationModel[],
        isModel?: boolean
    ): JSX.Element[] {
        let regionAllocationList = this.state.regionAllocationList;

        if (modelPortfolioAllocation) {
            regionAllocationList = modelPortfolioAllocation;
        }

        const regionGroupList = InsightsStore.getRegionGroup();
        const dict: { [key: string]: Array<number> } = {};
        let regionValueList: Array<number> = [];
        const returnValueList: Array<number> = [];
        const returnList: JSX.Element[] = [];

        if (regionGroupList) {
            regionGroupList.sort((x) => x.SortOrder);
            // 1. Render per region total from raw service data calculation.
            if (isModel) {
                regionAllocationList.map((item) => {
                    regionGroupList.map((area, idx) => {
                        regionValueList.push(this.getInvestmentRegionAllocationByGroupCode(area.Code, item));
                    });

                    dict[item.InstrumentCode + Guid.getNext()] = regionValueList;
                    regionValueList = [];
                });

                regionGroupList.map((item, index) => {
                    let sum = 0;

                    for (const key in dict) {
                        sum += dict[key][index];
                    }

                    returnValueList.push(sum);
                });

                returnValueList.map((item, index) => {
                    returnList.push(
                        <td className="cell-right" key={Guid.getNext() + index}>
                            {item.toFixed(2)}%
                        </td>
                    );
                });
            } else {
                // 2. Render per region total from Geographical allocation in Insight page
                const regionGroupTotalList: Array<InvestmentGeographicAllocationModel> = InvestmentRegionAllocationStore.getData();
                regionGroupList.map((item, index) => {
                    const regionValue = regionGroupTotalList.filter(
                        (x) => AreaGroupTypeMap[x.AreaGroupType] == item.Code
                    )[0];
                    returnList.push(
                        <td className="cell-right" key={Guid.getNext() + index}>
                            {regionValue.Value.toFixed(2)}%
                        </td>
                    );
                });
            }
        }

        return returnList;
    }

    private renderInvestmentRegionAllocation(regionAllocation: any, modelWight?: number): JSX.Element[] {
        const trList: JSX.Element[] = [];
        const regionGroupList = InsightsStore.getRegionGroup();

        if (regionGroupList) {
            regionGroupList.sort((x) => x.SortOrder);
            regionGroupList.map((item, index) => {
                let subStr = "-";
                let tdValue = this.getInvestmentRegionAllocationByGroupCode(item.Code, regionAllocation);

                if (Number(tdValue.toFixed(2)) != 0) {
                    if (modelWight) {
                        tdValue = tdValue * modelWight;
                    }
                    subStr = tdValue.toFixed(2) + "%";
                }
                trList.push(
                    <td className="cell-5 cell-right" key={Guid.getNext() + index}>
                        {subStr}
                    </td>
                );
            });
        }

        return trList;
    }

    private toggle(instrumentCode: string, index: number) {
        this.setState({ isLoading: true });
        let { expands } = this.state;

        const pushObj: expandedModel = {
            id: instrumentCode,
            index: index,
            isOpen: true,
            details: [],
        };

        let isFind = false;
        if (expands && expands.length > 0) {
            expands.map((item, i) => {
                if (item.index == index) {
                    isFind = true;
                    item.isOpen = !item.isOpen;
                }
            });
            if (!isFind) {
                expands.push(pushObj);
            }
        } else {
            expands = [];
            expands.push(pushObj);
        }

        const findObj = expands.filter((x) => x.index == index)[0];

        if (findObj.isOpen) {
            const { asAt } = this.props;
            InsightsAction.getModelPortfolioAssetRegionAllocation(instrumentCode, asAt, (val) => {
                findObj.details = val;
                this.setState({ expands: expands, isLoading: false });
            });
        } else {
            this.setState({ expands: expands, isLoading: false });
        }
    }

    private getInvestmentRegionAllocationByGroupCode(areaCode: string, regionAllocationModel: any): number {
        let value = 0;

        switch (areaCode) {
            case AreaGroupTypeMap[AreaGroupType.UK]:
                value = regionAllocationModel.UKAllocation;
                break;
            case AreaGroupTypeMap[AreaGroupType.EURO]:
                value = regionAllocationModel.EuroAllocation;
                break;
            case AreaGroupTypeMap[AreaGroupType.USA]:
                value = regionAllocationModel.UsaAllocation;
                break;
            case AreaGroupTypeMap[AreaGroupType.JAP]:
                value = regionAllocationModel.JapAllocation;
                break;
            case AreaGroupTypeMap[AreaGroupType.ASIA]:
                value = regionAllocationModel.AsiaAllocation;
                break;
            case AreaGroupTypeMap[AreaGroupType.EAST]:
                value = regionAllocationModel.EastAllocation;
                break;
            case AreaGroupTypeMap[AreaGroupType.SAMER]:
                value = regionAllocationModel.SamerAllocation;
                break;
            case AreaGroupTypeMap[AreaGroupType.AFRICA]:
                value = regionAllocationModel.AfricaAllocation;
                break;
            case AreaGroupTypeMap[AreaGroupType.CASH]:
                value = regionAllocationModel.CashAllocation;
                break;
            case AreaGroupTypeMap[AreaGroupType.OTHER]:
                value = regionAllocationModel.OtherAllocation;
            default:
                break;
        }

        return value * 100;
    }

    private getRegionAllocationByAreaGroupCode() {
        const { regionAllocationList, areaSelectValue } = this.state;
        let tempRegionAllocationList = regionAllocationList;

        if (areaSelectValue != AreaGroupType.ALL) {
            if (areaSelectValue != AreaGroupType.OTHER) {
                tempRegionAllocationList = regionAllocationList.filter(
                    (x) => x.SecurityType.toUpperCase() != Contents.Model
                );
            }
            const allocationList = [];

            switch (areaSelectValue) {
                case AreaGroupType.UK:
                    tempRegionAllocationList.map((item) => {
                        allocationList.push({
                            DisplayName: item.DisplayName,
                            Allocation: item.UKAllocation * 100,
                            SecurityType: item.SecurityType,
                        });
                    });
                    break;
                case AreaGroupType.EURO:
                    tempRegionAllocationList.map((item) => {
                        allocationList.push({
                            DisplayName: item.DisplayName,
                            Allocation: item.EuroAllocation * 100,
                            SecurityType: item.SecurityType,
                        });
                    });
                    break;
                case AreaGroupType.USA:
                    tempRegionAllocationList.map((item) => {
                        allocationList.push({
                            DisplayName: item.DisplayName,
                            Allocation: item.UsaAllocation * 100,
                            SecurityType: item.SecurityType,
                        });
                    });
                    break;
                case AreaGroupType.JAP:
                    tempRegionAllocationList.map((item) => {
                        allocationList.push({
                            DisplayName: item.DisplayName,
                            Allocation: item.JapAllocation * 100,
                            SecurityType: item.SecurityType,
                        });
                    });
                    break;
                case AreaGroupType.ASIA:
                    tempRegionAllocationList.map((item) => {
                        allocationList.push({
                            DisplayName: item.DisplayName,
                            Allocation: item.AsiaAllocation * 100,
                            SecurityType: item.SecurityType,
                        });
                    });
                    break;
                case AreaGroupType.EAST:
                    tempRegionAllocationList.map((item) => {
                        allocationList.push({
                            DisplayName: item.DisplayName,
                            Allocation: item.EastAllocation * 100,
                            SecurityType: item.SecurityType,
                        });
                    });
                    break;
                case AreaGroupType.SAMER:
                    tempRegionAllocationList.map((item) => {
                        allocationList.push({
                            DisplayName: item.DisplayName,
                            Allocation: item.SamerAllocation * 100,
                            SecurityType: item.SecurityType,
                        });
                    });
                    break;
                case AreaGroupType.AFRICA:
                    tempRegionAllocationList.map((item) => {
                        allocationList.push({
                            DisplayName: item.DisplayName,
                            Allocation: item.AfricaAllocation * 100,
                            SecurityType: item.SecurityType,
                        });
                    });
                    break;
                case AreaGroupType.CASH:
                    tempRegionAllocationList.map((item) => {
                        allocationList.push({
                            DisplayName: item.DisplayName,
                            Allocation: item.CashAllocation * 100,
                            SecurityType: item.SecurityType,
                        });
                    });
                    break;
                case AreaGroupType.OTHER:
                    tempRegionAllocationList.map((item) => {
                        allocationList.push({
                            DisplayName: item.DisplayName,
                            Allocation: item.OtherAllocation * 100,
                            SecurityType: item.SecurityType,
                            InstrumentCode: item.InstrumentCode,
                            TotalValue: item.TotalValue,
                        });
                    });
                    break;
                default:
                    break;
            }

            this.setState({ tempAllocationList: allocationList });
        }
    }

    private displayTotalLabel(): string {
        return "Portfolio Total";
    }
}
